<div class="tds-row tds-u-mt2" *ngIf="selectedWeek.weekNo != ''">
    <div class="tds-col-xxlg-4 tds-col-xlg-4 tds-col-lg-6 tds-col-md-7 tds-col-sm-12 tds-col-xs-12 " >
        <tds-dropdown 
            name="dropdown" 
            label="Period" 
            label-position="outside" 
            placeholder="Select week" 
            size="sm" 
            class="tds-u-mb2"
            open-direction="auto"> 
            <tds-dropdown-option value="{{week.weekNo}}" (click)="getTimeCard(week)" *ngFor="let week of weeks"> 
                <div *ngIf="week.status.toLowerCase() == 'submitted'">{{week.displayWeek}}<span style="color: blue">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Submitted - not yet transferred</span></div>
                <div *ngIf="week.status.toLowerCase() == 'approved'">{{week.displayWeek}} <span style="color: green">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<tds-icon slot="icon" size="20px" name="tick"></tds-icon>&nbsp; Submitted and transferred</span></div>
            </tds-dropdown-option> 
        </tds-dropdown>
    </div>
    <div class="tds-col-xxlg-4 tds-col-xlg-4 tds-col-lg-6 tds-col-md-7 tds-col-sm-12 tds-col-xs-12 " >
        <div class="tds-no-padding  tds-u-pt3" style="width:160px;"  
            *ngIf="selectedWeek.status.toLowerCase() == 'submitted'">
            <tds-button type="primary" 
                (click)="unlockTimeCard()"
                fullbleed  
                variant="danger" 
                id="deleteReportTemplatesModal"
                size="sm" 
                text="Revert to SAVED" >
            </tds-button>
        </div>
    </div>
</div>

<app-str-spinner [message]="spinnerMessage"></app-str-spinner>


<div class="tds-col-xxlg-12 tds-col-xlg-12 tds-col-lg-12 tds-col-md-12 tds-col-sm-12 tds-col-xs-12 tds-u-pt1  tds-u-m2" *ngIf="selectedWeek.weekNo == ''">
    No reports to show
</div>

<div class="tds-row table-container tds-u-m2">
    <tds-table 
        vertical-dividers="false" 
        compact-design="false" 
        responsive="true" 
        no-min-width
        *ngIf="selectedWeek.weekNo != ''" >
        <tds-table-toolbar>
            <div slot="end" class="tds-u-flex tds-u-align-items-center tds-u-h-100 tds-u-gap1">
                <h2 style="color: var(--tds-blue-500);">
                    {{selectedWeek.displayWeek.toUpperCase()}} 
                </h2>
            </div>
        </tds-table-toolbar>
        <tds-table-header>
            <tds-header-cell cell-value="Project"></tds-header-cell>
            <tds-header-cell cell-value="Task"></tds-header-cell>
            <tds-header-cell cell-value="Mon" [title]="getDateFromWeekDay(0)" text-Align="right"></tds-header-cell>
            <tds-header-cell cell-value="Tue" [title]="getDateFromWeekDay(0)" text-Align="right"></tds-header-cell>
            <tds-header-cell cell-value="Wed" [title]="getDateFromWeekDay(0)" text-Align="right"></tds-header-cell>
            <tds-header-cell cell-value="Thu" [title]="getDateFromWeekDay(0)" text-Align="right"></tds-header-cell>
            <tds-header-cell cell-value="Fri" [title]="getDateFromWeekDay(0)" text-Align="right"></tds-header-cell>
            <tds-header-cell cell-value="Sat" [title]="getDateFromWeekDay(0)" text-Align="right"></tds-header-cell>
            <tds-header-cell cell-value="Sun" [title]="getDateFromWeekDay(0)" text-Align="right"></tds-header-cell>
            <tds-header-cell cell-value="Total" [title]="getDateFromWeekDay(0)" text-Align="right" class="tds-u-pr2"></tds-header-cell>
        </tds-table-header>
        <tds-table-body>
            <tds-table-body-row *ngFor="let timecardRow of selectedWeek.timeCard.timecardRows">
                <tds-body-cell class="hourfieldtd">{{timecardRow.project.displayName}}</tds-body-cell>
                <tds-body-cell class="hourfieldtd">{{timecardRow.task.taskName}}: {{timecardRow.task.expType}}</tds-body-cell>
                <tds-body-cell><div style="text-align: right;white-space: nowrap;">{{timecardRow.mon}}</div></tds-body-cell>
                <tds-body-cell><div style="text-align: right;white-space: nowrap;">{{timecardRow.tue}}</div></tds-body-cell>
                <tds-body-cell><div style="text-align: right;white-space: nowrap;">{{timecardRow.wed}}</div></tds-body-cell>
                <tds-body-cell><div style="text-align: right;white-space: nowrap;">{{timecardRow.thu}}</div></tds-body-cell>
                <tds-body-cell><div style="text-align: right;white-space: nowrap;">{{timecardRow.fri}}</div></tds-body-cell>
                <tds-body-cell><div style="text-align: right;white-space: nowrap;">{{timecardRow.sat}}</div></tds-body-cell>
                <tds-body-cell><div style="text-align: right;white-space: nowrap;">{{timecardRow.sun}}</div></tds-body-cell>
                <tds-body-cell class="hourfieldtd  day-total">
                    <div class=" tds-u-pr2" style="text-align: right;white-space: nowrap;">
                        {{timecardRow.total.toFixed(1)}} h
                    </div>
                </tds-body-cell>
            </tds-table-body-row>

            <tds-table-body-row class="total-row">
                <tds-body-cell class="tds-headline-06" >
                    <div class="tds-u-pt2 day-total">
                        Sum:
                    </div>
                </tds-body-cell>                
                <tds-body-cell class="tds-headline-06" >
                    <div class="tds-u-pt2 day-total">
                        &nbsp;
                    </div>
                </tds-body-cell>
                <tds-body-cell class="tds-headline-06" >
                    <div class="tds-u-pt2" style="text-align: right;white-space: nowrap;">
                        {{ selectedWeek.timeCard.monTotal.toFixed(1) }} h
                    </div>
                </tds-body-cell>
                <tds-body-cell class="tds-headline-06" >
                    <div class="tds-u-pt2" style="text-align: right;white-space: nowrap;">
                        {{ selectedWeek.timeCard.tueTotal.toFixed(1) }} h
                    </div>
                </tds-body-cell>
                <tds-body-cell class="tds-headline-06" >
                    <div class="tds-u-pt2" style="text-align: right;white-space: nowrap;">
                        {{ selectedWeek.timeCard.wedTotal.toFixed(1) }} h
                    </div>
                </tds-body-cell>
                <tds-body-cell class="tds-headline-06" >
                    <div class="tds-u-pt2" style="text-align: right;white-space: nowrap;">
                        {{ selectedWeek.timeCard.thuTotal.toFixed(1) }} h
                    </div>
                </tds-body-cell>
                <tds-body-cell class="tds-headline-06" >
                    <div class="tds-u-pt2" style="text-align: right;white-space: nowrap;">
                        {{ selectedWeek.timeCard.friTotal.toFixed(1) }} h
                    </div>
                </tds-body-cell>
                <tds-body-cell class="tds-headline-06" >
                    <div class="tds-u-pt2" style="text-align: right;white-space: nowrap;">
                        {{ selectedWeek.timeCard.satTotal.toFixed(1) }} h
                    </div>
                </tds-body-cell>
                <tds-body-cell class="tds-headline-06" >
                    <div class="tds-u-pt2" style="text-align: right;white-space: nowrap;">
                        {{ selectedWeek.timeCard.sunTotal.toFixed(1) }} h
                    </div>
                </tds-body-cell>
                <tds-body-cell class="tds-headline-06" >
                    <div class="tds-u-pt2" style="text-align: right;white-space: nowrap;padding-right: 16px;">
                        {{selectedWeek.timeCard.total.toFixed(1)}} h
                    </div>
                    <div class="pull-right" >
                        &nbsp;                    
                    </div>
                </tds-body-cell>
            </tds-table-body-row>
        </tds-table-body>
    </tds-table>
</div>


<div class="tds-col-xxlg-4 tds-col-xlg-4 tds-col-lg-6 tds-col-md-6 tds-col-sm-12 tds-col-xs-12 tds-u-mt2">
    <tds-textarea 
        rows="3"  
        name="EmpComment"
        class="hourfieldinput"
        state="default"
        label="Comment"
        label-position="outside"
        no-min-width
        ngDefaultControl 
        placeholder="Comment text"  
        [(ngModel)]="selectedWeek.timeCard.empComment" 
        [disabled]="true">
    </tds-textarea> 
</div>

